const genericUrl = process.env.REACT_APP_API_URL;

export async function PostUseNotaJavamon(idAct: string, idUser: string, idJavamon: string) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/activitats/${idAct}/usuaris/${idUser}/javamon/${idJavamon}/nota`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.ok;
    } catch (e) {
        console.error(e);
        return false;
    }
}
